import React from "react";
import { useNavigate } from "react-router-dom";
import arrowIconWhite from "../../assets/arrowWhite.svg";

const Button = ({ ButtonText, icon, path='', type, disable = false, hoverIcon, smallContainer}) => {
  const navigate = useNavigate();

  return (
    <div className={`relative group inline-flex items-center ${smallContainer ? " mt-4 w-fit justify-start": "justify-center"}`}>
      {ButtonText === "Request a Demo Today" ||
      ButtonText === "Request a Demo" ? (
        <>
          <button
            type={type}
            onClick={() => navigate(path)}
            disabled={disable}
            className="group w-auto flex items-center justify-center gap-2 py-2 px-4 md:py-3 md:px-6 font-bold text-lg text-darkPurple hover:text-white rounded-full border-2 border-darkPurple bg-white hover:bg-darkPurple transition-all disabled:border-[#510ac980] disabled:opacity-50"
          >
            <p className="font-sans font-semibold leading-6 text-sm ">
              {ButtonText}
            </p>
            {icon && (
              <>
                <img
                  src={icon}
                  height={16}
                  width={16}
                  alt="arrow"
                  className="inline-block group-hover:hidden"
                />
                <img
                  src={arrowIconWhite}
                  height={16}
                  width={16}
                  alt="arrow"
                  className="hidden group-hover:inline-block"
                />
              </>
            )}
          </button>
          <span className="hidden group-hover:inline-block absolute top-[60px] inset-x-0 mx-auto w-fit text-sm font-medium text-darkGray">
            Coming Soon
          </span>
        </>
      ) : (
        <button
          type={type}
          onClick={() => navigate(path)}
          disabled={disable}
          className={`group w-auto flex items-center justify-center gap-2 py-2 px-4 md:py-3 md:px-6 font-bold text-lg text-darkPurple hover:text-white rounded-full border-2 border-darkPurple bg-white hover:bg-darkPurple transition-all disabled:border-[#510ac980] disabled:opacity-50  ${smallContainer ? "w-auto" : "w-full"}`}
        >
          <p className="font-sans font-semibold leading-6 text-sm">
            {ButtonText}
          </p>
          {icon && (
            <>
              <img
                src={icon}
                height={16}
                width={16}
                alt="arrow"
                className="inline-block group-hover:hidden"
              />
              <img
                src={!hoverIcon? arrowIconWhite : hoverIcon}
                height={16}
                width={16}
                alt="arrow"
                className="hidden group-hover:inline-block"
              />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default Button;
